import { siteConfig, services } from "@/lib/data";

export function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteConfig.name,
    legalName: siteConfig.fullName,
    url: siteConfig.url,
    description: siteConfig.description,
    email: siteConfig.email,
    telephone: siteConfig.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Jl. Tanah Abang II No.74A, Petojo Sel., Kecamatan Gambir",
      addressLocality: "Jakarta Pusat",
      addressRegion: "DKI Jakarta",
      postalCode: "10160",
      addressCountry: "ID",
    },
    sameAs: [
      siteConfig.socials.linkedin,
      siteConfig.socials.instagram,
      siteConfig.socials.github,
      siteConfig.socials.youtube,
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: siteConfig.phone,
      contactType: "customer service",
      availableLanguage: ["Indonesian", "English"],
    },
  };

  return (
    <script
      id="organization-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function WebSiteSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteConfig.name,
    url: siteConfig.url,
    description: siteConfig.description,
    inLanguage: "id-ID",
    potentialAction: {
      "@type": "SearchAction",
      target: `${siteConfig.url}/blog?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <script
      id="website-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function ServiceSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Layanan Naincode",
    description: "Daftar layanan teknologi yang disediakan oleh PT. Naincode Inti Technology",
    itemListElement: services.map((service, index) => ({
      "@type": "Service",
      position: index + 1,
      name: service.title,
      description: service.description,
      serviceType: "Software Development",
      provider: {
        "@type": "Organization",
        name: siteConfig.fullName,
        url: siteConfig.url,
      },
      areaServed: {
        "@type": "Country",
        name: "Indonesia",
      },
    })),
  };

  return (
    <script
      id="service-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function FAQSchema() {
  const faqs = [
    {
      question: "Berapa biaya konsultasi di Naincode?",
      answer: "Konsultasi awal 100% GRATIS dan tanpa komitmen. Anda bisa mendiskusikan kebutuhan project dan mendapatkan rekomendasi solusi dari tim expert kami.",
    },
    {
      question: "Berapa lama waktu pengerjaan project?",
      answer: "Tergantung kompleksitas project. Landing page biasanya 2-4 minggu, web application 2-6 bulan, dan enterprise system 6-12 bulan. Timeline detail akan dibahas saat konsultasi.",
    },
    {
      question: "Apakah Naincode menyediakan maintenance setelah project selesai?",
      answer: "Ya, kami menyediakan paket maintenance dan support berkelanjutan untuk memastikan aplikasi Anda tetap berjalan optimal dengan update berkala dan monitoring 24/7.",
    },
    {
      question: "Teknologi apa yang digunakan Naincode?",
      answer: "Kami menggunakan teknologi modern dan terpercaya seperti React, Next.js, Node.js, TypeScript, PostgreSQL, Docker, Kubernetes, AWS, dan lainnya sesuai kebutuhan project.",
    },
  ];

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <script
      id="faq-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
